import service from './service';
import { trimString } from '../utils/common';

export default {
  // 用户自己查询是否简历被禁用
  isBan(id) {
    return service.get(`/api/v1/resume/${id}/is-ban`);
  },
  getMyResume() {
    return service.get('/api/v1/user/resume');
  },
  editMyResume(params) {
    return service.patch('/api/v1/resume', params, { manual: true });
  },
  getUserInfo() {
    return service.get('/api/v1/user');
  },
  editUserInfo(params) {
    return service.patch('/api/v1/user', params);
  },
  searchCity(params) {
    params = trimString(params)
    return service.get('/api/v1/address/city', { params });
  },
  getJobArea() {
    return service.get('/api/v1/info/subarea/list');
  },
  getProfessionList() {
    return service.get('/api/v1/company/subarea/list');
  },
  addWorkExp(params) {
    return service.post('/api/v1/resume/works', params);
  },
  editWorkExp(id, params) {
    return service.put('/api/v1/resume/works/' + id, params);
  },
  delWorkExp(id) {
    return service.delete('/api/v1/resume/works/' + id);
  },
  addEduExp(params) {
    return service.post('/api/v1/resume/educations', params);
  },
  editEduExp(id, params) {
    return service.put('/api/v1/resume/educations/' + id, params);
  },
  delEduExp(id) {
    return service.delete('/api/v1/resume/educations/' + id);
  },
  addProjectExp(params) {
    return service.post('/api/v1/resume/projects', params);
  },
  editProjectExp(id, params) {
    return service.put('/api/v1/resume/projects/' + id, params);
  },
  delProjectExp(id) {
    return service.delete('/api/v1/resume/projects/' + id);
  },
  addTrainExp(params) {
    return service.post('/api/v1/resume/trains', params);
  },
  editTrainExp(id, params) {
    return service.put('/api/v1/resume/trains/' + id, params);
  },
  delTrainExp(id) {
    return service.delete('/api/v1/resume/trains/' + id);
  },
  getDict() {
    return service.get('/api/v1/dict');
  }
};



// WEBPACK FOOTER //
// ./src/api/personal-resume.js